export default "__VITE_ASSET__h_4XYRda__"